import { SvgIconProps } from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";
import ListIcon from "@mui/icons-material/List";
import React, { FunctionComponent } from "react";

const PREFIX = "ListsIcon";

const classes = {
	iconStyle: `${PREFIX}iconStyle`,
};

const StyledListIcon = styled(ListIcon)((
	{
		theme,
	},
) => ({
	[`&.${classes.iconStyle}`]: {
		fontSize: 18,
	},
}));

export const ListsIcon: FunctionComponent<SvgIconProps> = (props) => {
	return <StyledListIcon {...props} className={classes.iconStyle} />;
};

export default ListsIcon;